<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="客服绩效" name="summary" style="height: 100%;">
				<summary-index v-show="activeName=='summary'" />
			</el-tab-pane>
			<el-tab-pane label="客服账台" name="clickfarm" style="height: 100%;">
				<clickfarm-index v-show="activeName=='clickfarm'" />
			</el-tab-pane>
			<el-tab-pane label="损失登记表" name="tradelossrecord" style="height: 100%;">
				<tradelossrecord-index v-if="activeName=='tradelossrecord'" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import summaryIndex from './summary/index.vue'
	import clickfarmIndex from './clickfarm/index.vue'
	import tradelossrecordIndex from './tradelossrecord/index.vue'
	
	export default {
		props: {

		},
		data() {
			return {
				activeName: 'summary',
				activeIndex: '',
				departmentChildren: [],

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			summaryIndex,
			tradelossrecordIndex,
			clickfarmIndex
		}
	}
</script>